export const CONSULTATION_URL =
  "https://calendly.com/d/cxy2-dy2-tqk/mutetaxes-consultation-call";
export const SPECIALIST_URL =
  "https://api.whatsapp.com/send?phone=447445609826&text=Hi%20MuteTaxes%20team!";
